import { gql } from "@apollo/client";

// New mutation
export const GENERATE_PDF = gql`
  mutation generatePdf($id: String!) {
    generatePdf(id: $id) {
      url
      success
      messages
    }
  }`;

export const INVOICE_LIST = gql`
query getInvoiceList {
  getInvoiceList{
    items {
      id
      total
      name
      image
      petId
      city
      time
      date
      locationName
      timeZone
      status
      invoiceUrl
      source
      promoCode
    }
    messages
    success
  }
}`;

